



















import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import SmoothShow from '@/views/common/SmoothShow.vue';


@Component({
  components: {SmoothShow},
})
export default class StyledSelect<T> extends Vue {
  @Prop({required: true})
  private readonly value: any;

  @Prop({required: true})
  private readonly groupName!: string;

  @Model('select')
  private readonly currentSelection!: any;

  get isSelected() {
    return this.currentSelection === this.value;
  }

  public handleChange() {
    this.$emit('select', this.value);
  }
}
